import translateUtils from "./TranslateUtils";

const TranslateConfig = function (
    $translateProvider,
    AccuCodeServiceProvider,
    translateServiceProvider
) {
    const cacheBustEveryFifteenMinutes = Math.floor(Date.now() / 900000); // refresh cache every 15 minutes TODO use a hash
    const accuCode = AccuCodeServiceProvider.$get(0).getAccuCode();
    const locale = translateServiceProvider.$get(0).getUserLocale();

    try {
        $translateProvider.useStaticFilesLoader({
            prefix: translateUtils.getCustomizationPath(accuCode),
            suffix: ".json?v=" + cacheBustEveryFifteenMinutes
        });
    } catch (err) {
        if (accuCode === "Empower") {
            throw err;
        }
        try {
            $translateProvider.useStaticFilesLoader({
                prefix: translateUtils.getCustomizationPath("Empower"),
                suffix: ".json?v=" + cacheBustEveryFifteenMinutes
            });
        } catch (err) {
            throw err;
        }
    }
    $translateProvider.preferredLanguage(locale);

    // HTML in the translated content _should_ be sanitized for security reasons,
    // and there is a warning in the console telling us as much. However, we
    // are unable to use the 'sanitize' or 'escape' strategies until we stop
    // allowing arbitrary HTML in custom content. For example, the "contact us",
    // "feedback", and "email us" links are all defined in JSON files in
    // ui-style-guide.
    //
    // $translateProvider.useSanitizeValueStrategy('sanitize');
};

TranslateConfig.$inject = [
    "$translateProvider",
    "AccuCodeServiceProvider",
    "translateServiceProvider"
];

export default TranslateConfig;
